import { Component } from '@angular/core';

@Component({
    selector: 'app-unlock-icon',
    templateUrl: './unlock-icon.component.html',
    styleUrls: ['./unlock-icon.component.scss'],
    standalone: false
})
export class UnlockIconComponent {}
